import {
  authenticationReducer,
  campaignReducer,
  clientReducer,
  organizationReducer,
  fileUploadReducer,
  influencersReducer,
  LogoutUser,
  mailVerifyReducer,
  projectReducer, reportReducer, segmentReducer,
  templateReducer,
  templateSectionReducer,
  usersReducer,
  variableReducer,
  settingsReducer,
  registrationPlatformReducer,
  packageReducer,
  trackingTypeReducer,
  industriesReducer,
  logsReducer,
  mailerDomainReducer,
  influencerSsoReducer,
  mailerServiceProviderReducer
} from '@app/stores';
import {ActionReducer, MetaReducer} from '@ngrx/store';

export const appReducers = {
  authentication: authenticationReducer,
  project: projectReducer,
  users: usersReducer,
  influencer: influencersReducer,
  campaign: campaignReducer,
  template: templateReducer,
  variable: variableReducer,
  templateSection: templateSectionReducer,
  files: fileUploadReducer,
  clients: clientReducer,
  organizations: organizationReducer,
  mailVerify: mailVerifyReducer,
  report: reportReducer,
  segments: segmentReducer,
  settings: settingsReducer,
  registrationPlatform: registrationPlatformReducer,
  packages: packageReducer,
  trackingType: trackingTypeReducer,
  industries: industriesReducer,
  logs: logsReducer,
  mailerDomains: mailerDomainReducer,
  influencerSso: influencerSsoReducer,
  mailerServiceProviders: mailerServiceProviderReducer,
};

export function logout(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    if (action !== null && action.type === LogoutUser.type) {
      state = undefined;
    } else {
      if (state) {
        state = getResetState(state);
      }
    }
    return reducer(state, action);
  };
}

function getResetState(state) {
  return {
    authentication: {
      ...state.authentication,
      success: '',
      error: ''
    },
    project: {
      ...state.project,
      success: '',
      error: ''
    },
    users: {
      ...state.users,
      success: '',
      error: ''
    },
    influencer: {
      ...state.influencer,
      success: '',
      error: ''
    },
    campaign: {
      ...state.campaign,
      success: '',
      error: ''
    },
    template: {
      ...state.template,
      success: '',
      error: ''
    },
    variable: {
      ...state.variable,
      success: '',
      error: ''
    },
    templateSection: {
      ...state.templateSection,
      success: '',
      error: ''
    },
    files: {
      ...state.files,
      success: '',
      error: ''
    },
    clients: {
      ...state.clients,
      success: '',
      error: ''
    },
    organizations: {
      ...state.organizations,
      success: '',
      error: ''
    },
    packages: {
      ...state.packages,
      success: '',
      error: ''
    },
    mailVerify: {
      ...state.mailVerify,
      success: '',
      error: ''
    },
    report: {
      ...state.report,
      success: '',
      error: ''
    },
    segments: {
      ...state.segments,
      success: '',
      error: ''
    },
    settings: {
      ...state.settings,
      success: '',
      error: ''
    },
    registrationPlatform: {
      ...state.registrationPlatform,
      success: '',
      error: ''
    },
    token: {
      ...state.token,
      success: '',
      error: ''
    },
    industries: {
      ...state.industries,
      success: '',
      error: ''
    },
    logs: {
      ...state.logs,
      success: '',
      error: ''
    },
    mailerDomains: {
      ...state.mailerDomains,
      success: '',
      error: ''
    },
    influencerSso: {
      ...state.influencerSso,
      success: '',
      error: ''
    },
    mailerServiceProviders: {
      ...state.mailerServiceProviders,
      success: '',
      error: ''
    },
  };
}

export const metaReducers: MetaReducer[] = [logout];
